import React, { useEffect } from 'react';
import { Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import classNames from 'classnames';
import { useFormikContext } from 'formik';

import { FieldBuilder } from '@components/Forms';
import { areaApi, countryApi } from '@reducers/geo';
import { getSalutationChoices } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const ProfileNameField = () => {
  const context = useFormikContext();
  const builder = new FieldBuilder(context);
  return builder.renderCharField(
    'End user name',
    'profileName',
    {},
    { disabled: true }
  );
};

export const TypeOfProfileField = ({ disabled }) => {
  const context = useFormikContext();
  const builder = new FieldBuilder(context);

  const TypeOfProfileChoices = {
    isLoading: false,
    isFetching: false,
    isError: false,
    data: [
      { value: '2', name: 'Business' },
      { value: '3', name: 'Residential' },
    ],
  };
  return builder.renderSelectField(
    'Type of Profile',
    'accountType',
    TypeOfProfileChoices,
    undefined,
    {},
    { disabled }
  );
};

export const ProfileDataForm = ({ fields, addressDocument }) => {
  const [searchParams] = useSearchParams();
  const context = useFormikContext();
  const builder = new FieldBuilder(context);

  const country = searchParams.get('country') || '';
  const { values } = context;

  const countries = countryApi.useGetForInputForSelectQuery();
  const areas = areaApi.useGetForInputForSelectQuery(
    values.country ? { id: values.country } : skipToken
  );
  useEffect(() => {
    if (context.initialValues.country === values.country) {
      return;
    }
    context.setFieldValue('area', '');
  }, [values.country]);

  useEffect(() => {
    if (!addressDocument) {
      return;
    }
    if (addressDocument.country_specific) {
      context.setFieldValue('country', country);
    }
  }, [addressDocument]);

  const selectFieldsData = {
    salutation: { query: getSalutationChoices },
    area: {
      query: areas,
      blankValue: values.country
        ? 'Select area'
        : 'Select country to see areas',
    },
    country: {
      query: countries,
      selectProps: addressDocument
        ? {
            disabled: addressDocument.country_specific,
          }
        : {},
    },
  };
  return (
    <>
      <Row className="mb-2">
        <div className="text-center">End User Data</div>
      </Row>
      <hr />
      {fields.map(({ field, label, required }) =>
        field in selectFieldsData
          ? builder.renderSelectField(
              label,
              field,
              selectFieldsData[field].query,
              selectFieldsData[field].blankValue,
              {
                className: classNames({
                  textRed: required && !values[field],
                  textGreen: required && values[field],
                }),
              },
              selectFieldsData[field].selectProps || {}
            )
          : builder.renderCharField(label, field, {
              className: classNames({
                textRed: required && !values[field],
                textGreen: required && values[field],
              }),
            })
      )}
    </>
  );
};
